import React, { FC, useEffect, useState } from "react";
import { Col, Container, Row } from "reactstrap";
import { AEABatchGrid } from "@components/";
import { FormProaFEPresenter } from "@presenters/screens/form-proa-fe.presenter";
import { IFEStep4MriIndicadorDtoModel } from "@models/*";
import { Utilities } from "@utils";
import ErrorTable from '@/components/ui/aea-error-table/aea-error-table';
import { Toast } from "devextreme-react/toast";
export interface IMRIIndicators {
  tabIndex: number;
  subventionCodeId: number;
  dataColumns: any;
  stepMriData: IFEStep4MriIndicadorDtoModel[];
  startDate: any;
  endDate: any;
  alertEndDate: boolean;
  step1: any;
  showAlerts: boolean;
  handleSwitch?(): void;
  setStep4MRI(stepMriData: IFEStep4MriIndicadorDtoModel[]): void;
}

const MRIIndicators: FC<IMRIIndicators> = (props) => {
  const [mriIndicatorsGridData, setMriIndicatorsGridData] = useState(null);
  const [modalExcel, setModalExcel] = useState<boolean>(false);
  const [readOnly, setReadOnly] = useState(false);
  const [gridDataExcel, setGridDataExcel] = useState(null);

  const [stepData, setStepData] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [checkLE, setCheckLE] = useState(false);
  const [Alerts, setAlerts] = useState(false);

  const [toastConfig, setToastConfig] = React.useState({
		isVisible: false,
		type: null,
		message: "",
	});

  const handleLoad = () => {
    props.handleSwitch()
    setAlerts(true)
  }

  const presenter = new FormProaFEPresenter({
    state: {
      step1: props.step1,
      readOnly: readOnly,
      dataColumns: props.dataColumns,
      subventionCodeId: props.subventionCodeId,
      mriIndicatorsGridData: mriIndicatorsGridData,
      stepMriData: props.stepMriData,
      startDate: props.startDate,
      modalExcel,
      setReadOnly: setReadOnly,
      setModalExcel,
      setGridDataExcel,
      setMriIndicatorsGridData: setMriIndicatorsGridData
    },
    endDate: props.endDate,
    setPartialSave: props.setStep4MRI,
    handleLoad: handleLoad,
    refresh,
    refreshPage: setRefresh,
  });

  useEffect(() => {        
    setRefresh(refresh => !refresh)
  }, [props.startDate, props.endDate])

  useEffect(() => {
    if(props.stepMriData !== undefined) presenter.initializeStep4MriIndicators(props.tabIndex);
  }, [props.stepMriData, refresh, props.step1]);

  useEffect(() => {
    if (!Utilities.isNullEmptyObject(mriIndicatorsGridData)){
      presenter.testRender(mriIndicatorsGridData, checkLE)
      getMriData()
    } 
  }, [props.stepMriData, mriIndicatorsGridData, modalExcel, gridDataExcel, checkLE, props.step1])

  const onHidingToast = () => {
      setToastConfig({
      ...toastConfig,
      isVisible: false,
    });
  };

  const handleChange = (option: any, column: any) => {
    let message = presenter.handleChangeValue(option)
    if(!!message){
      setToastConfig({
        isVisible: true,
        type: 'info',
        message
      })
    }
  }

  const getMriData = () => {
    setStepData(
      <Row>
        <Col>
          <AEABatchGrid {...mriIndicatorsGridData} handleChange={handleChange} onCellPreRender={presenter.onCellPreRender} setCheckLEMri={setCheckLE} checkContent currentData={props.stepMriData !== undefined} 
          modalExcel={modalExcel} gridDataExcel={gridDataExcel} presenter={presenter}></AEABatchGrid>
        </Col>
      </Row>
    )
  }
  
  const render = () => {
    if (!Utilities.isNullEmptyObject(props.dataColumns)) {
      return (
        <Container fluid={true} style={{position: 'relative'}}>
          {((props.showAlerts || Alerts) && (presenter.missingSLIndicators(mriIndicatorsGridData)) && props.stepMriData !== undefined) &&
            <div style={{width:"100%", textAlign:"center"}}>
              <h6 style={{color:"red", padding:"0 1rem", minHeight: "31px"}}>{presenter.currentLabels.get("AlertMRIIndicators")}</h6>
            </div>
          }
          {(mriIndicatorsGridData?.gridProps?.id && !!stepData && props.stepMriData !== undefined) && 
            <ErrorTable 
              gridId={mriIndicatorsGridData?.gridProps?.id} 
              showAlerts={Alerts || props.showAlerts}
              checkFunction={(col, item) => presenter.checkRequiredFields(col, item)}
            />
          }
          {(mriIndicatorsGridData?.gridProps?.id && !!stepData && props.stepMriData !== undefined && !props.alertEndDate && !Alerts && !props.showAlerts) && 
            <ErrorTable 
              paintColumn
              gridId={mriIndicatorsGridData?.gridProps?.id} 
              showAlerts={!props.alertEndDate}
              checkFunction={presenter.checkEndDate}
            />
          }
          {!!stepData && stepData}
          <Toast
            visible={toastConfig.isVisible}
            message={toastConfig.message}
            type={toastConfig.type}
            onHiding={onHidingToast}
            displayTime={10000}
          />
        </Container>
      );
    }
    return <div></div>;
  };
  return render();
};

export default MRIIndicators;
